import type { SVGProps } from "react";
export interface DatabaseIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DatabaseIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DatabaseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 15.123a9 9 0 0 1-.767.382c-1.62.709-3.782 1.12-6.109 1.12s-4.486-.411-6.106-1.12a9 9 0 0 1-.768-.382V18.5c0 .112.047.306.312.58.271.28.718.585 1.356.865 1.275.558 3.115.93 5.206.93s3.932-.373 5.207-.93c.638-.28 1.085-.584 1.356-.864.265-.275.313-.47.313-.58zm2.25 3.377c0 .856-.4 1.583-.944 2.145-.539.557-1.265 1.007-2.073 1.36-1.62.71-3.782 1.12-6.109 1.12s-4.486-.41-6.106-1.12c-.809-.353-1.535-.803-2.073-1.36-.544-.562-.945-1.29-.945-2.145v-13a1.125 1.125 0 0 1 2.25 0V12c0 .11.046.306.312.581.271.28.718.583 1.356.863 1.275.557 3.115.931 5.206.931s3.932-.373 5.207-.931c.638-.28 1.085-.583 1.356-.863.266-.275.313-.47.313-.582V5.5a1.125 1.125 0 0 1 2.25 0z"
      />
      <path
        fill={color}
        d="M18.875 5.5c0-.111-.048-.306-.313-.58-.271-.28-.718-.585-1.356-.865-1.275-.557-3.115-.93-5.207-.93-2.09 0-3.93.373-5.206.93-.638.28-1.085.584-1.356.864-.265.275-.312.47-.312.581s.046.306.312.581c.271.28.718.583 1.356.863 1.275.558 3.115.931 5.206.931s3.932-.373 5.207-.931c.638-.28 1.085-.583 1.356-.863.266-.275.313-.47.313-.581m2.25 0c0 .855-.4 1.582-.944 2.144-.539.557-1.265 1.007-2.073 1.36-1.62.71-3.782 1.122-6.109 1.122s-4.486-.412-6.106-1.121c-.81-.354-1.535-.804-2.073-1.361-.544-.562-.945-1.289-.945-2.144s.401-1.583.945-2.145c.538-.557 1.264-1.007 2.073-1.36 1.62-.71 3.78-1.12 6.106-1.12s4.488.41 6.109 1.12c.808.353 1.534.803 2.073 1.36.543.562.944 1.29.944 2.145"
      />
    </svg>
  );
}
